export const TYPES_PREFIX = 'dashboard/';
